import gql from 'graphql-tag';

export default gql`
	query ShipmentConfirmStatus {
		shipmentConfirmStatus @client {
			isConfirm
		}
	}
`;
